import { OtpCode } from 'Component';
import { asRem } from 'utils';

export const CodeInput = ({ value, onChange, error }) => {
  return (
    <fieldset aria-labelledby="otp-label" aria-describedby="otp-hint">
      <div className="sr-only">
        <p id="otp-label">Bestätigungscode eingeben</p>
        <p id="otp-hint">Gib den 6-stelligen Code aus der E-Mail ein.</p>
      </div>
      <OtpCode
        inputMode="numeric"
        name="otp-token"
        className="code-field"
        type="text"
        pattern="[0-9]*"
        fields={6}
        value={value}
        onChange={onChange}
        inputStyle={{
          margin: asRem(4),
          width: asRem(40),
          borderRadius: asRem(6),
          fontSize: asRem(20),
          height: asRem(53),
          padding: 0,
          color: '#717171',
          textAlign: 'center',
          border: error ? '1px solid red' : '1px solid #ededed',
          backgroundColor: '#ededed'
        }}
      />
    </fieldset>
  );
};
